export const US_TIME_ZONE = "America/Los_Angeles";
export const US_TIME_ZONE_LABEL = "Pacific Time";

function normalizeDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatUsDate(value, fallback = "N/A") {
  const date = normalizeDate(value);
  if (!date) return fallback;

  return new Intl.DateTimeFormat("en-US", {
    timeZone: US_TIME_ZONE,
    dateStyle: "medium",
  }).format(date);
}

export function formatUsDateTime(value, fallback = "N/A") {
  const date = normalizeDate(value);
  if (!date) return fallback;

  return new Intl.DateTimeFormat("en-US", {
    timeZone: US_TIME_ZONE,
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

export function formatUsDateTimeWithZone(value, fallback = "N/A") {
  const formatted = formatUsDateTime(value, fallback);
  return formatted === fallback ? fallback : `${formatted} PT`;
}
